module.exports = __webpack_public_path__ + "static/img/icon1.ee9c3a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon1.png
// module id = jsOG
// module chunks = 173